import React, { useState, useEffect } from "react";
import Button from "web/components/Button";
import DatePicker from "web/components/DatePicker";
import * as moment from "moment";
import DropDown from "web/components/DropDown";
import styled from "styled-components";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import {deliveryRequirements} from "../Constants"
import { Form, Formik } from "formik";
import * as Yup from "yup";

export default ({ isOpen, toggle, callBackFun, currentPage, fieldValues }) => {
  let toDate = new Date();
  let fromDate = new Date();
  fromDate.setDate(fromDate.getDate() - 31);
  toDate.setDate(fromDate.getDate() + 31);
  const [requestedFromDate, setRequestedFromDate] = useState(fromDate.toISOString().substr(0, 10));
  const [requestedToDate, setRequestedToDate] = useState(toDate.toISOString().substr(0, 10));

  const VALIDATION_SCHEMA = Yup.object().shape({});

  let statusArr;
  if (currentPage === 0) {
    statusArr = [{ label: "Pending", value: "PENDING" }];
  }
  if (currentPage === 1) {
    statusArr = [
      { label: "All", value: "ALL" },
      { label: "Assigned", value: "ASSIGNED" },
      { label: "Shipped", value: "SHIPPED" },
      { label: "Hold", value: "HOLD" },
      { label: "Reschedule Request", value: "RESCHEDULE REQUESTED" },
      { label: "Reschedule", value: "RESCHEDULED" },
    ];
  }
  if (currentPage === 2) {
    statusArr = [{ label: "Delivered", value: "DELIVERED" }];
  }
  if (currentPage === 3) {
    statusArr = [{ label: "Complete", value: "COMPLETE" }];
  }
  if (currentPage === 4) {
    statusArr = [{ label: "Canceled", value: "CANCELLED" }];
  }
  if (currentPage === 5) {
    statusArr = [{ label: "Claim", value: "CLAIM" }];
  }
  if (currentPage === 6) {
    statusArr = [
      { label: "All", value: "ALL" },
      { label: "Assigned", value: "ASSIGNED" },
      { label: "Shipped", value: "SHIPPED" },
      { label: "Delivered", value: "DELIVERED" },
      { label: "Claim", value: "CLAIM" },
      { label: "Complete", value: "COMPLETE" },
      { label: "Rescheduled", value: "RESCHEDULED" },
      { label: "Canceled", value: "CANCELLED" },
      { label: "Hold", value: "HOLD" },
    ];
  }

  useEffect(() => {
    setRequestedFromDate(fieldValues.fromDateOrderFilter)
    setRequestedToDate(fieldValues.toDateOrderFilter)
  }, [currentPage]);

  const getAuthInitialValues = () => {
    return {
      bidStatus: fieldValues.bidStatus,
      deliveryReq: fieldValues.deliveryReq,
      fromDateOrderFilter: moment(fieldValues.fromDateOrderFilter).format('MM/DD/YYYY'),
      toDateOrderFilter: moment(fieldValues.toDateOrderFilter).format('MM/DD/YYYY'),
    };
  };

  return (
    <div className="alert-modal">
      <Formik
        enableReinitialize
        initialValues={getAuthInitialValues()}
        validationSchema={VALIDATION_SCHEMA}
        onSubmit={(values) => { }}
      >
        {(props) => {
          const {
            setFieldValue,
          } = props;

          return (
            <>
              <Form>
                <Modal isOpen={isOpen} centered={true} size="md">
                  <ModalHeader
                    toggle={() => {
                      toggle();
                    }}
                  >
                    <h6>Filter by </h6>
                  </ModalHeader>
                  <ModalBody>
                    <DropDownWrapper>
                      <div className="dropDown">
                        <label>Order Status</label>
                        {(currentPage === 1 || currentPage === 6) ? (
                          <DropDown
                            name="bidStatus"
                            data={statusArr}
                            placeholder=""
                            searchDropDown={props.values.bidStatus}
                            onChangeHandler={(event) => {
                              setFieldValue("bidStatus", event.value);
                            }}
                          />
                        ) : (
                          <div>
                            <span style={{"margin-left": "10px","font-size": "1rem",}}>
                              {statusArr[0].value}
                            </span>
                          </div>
                        )}
                      </div>

                      {currentPage > 0 &&
                        <div className="dropDown">
                          <label>Delivery Requirements</label>
                          <DropDown
                            name="deliveryReq"
                            data={deliveryRequirements}
                            placeholder=""
                            searchDropDown={props.values.deliveryReq}
                            onChangeHandler={(event) => {
                              setFieldValue("deliveryReq", event.value);
                            }}
                          />
                        </div>
                      }
                    </DropDownWrapper>
                    <SelectWrapper>
                      <label>Requested Date</label>
                      <div>
                        <DatePicker name="fromDateOrderFilter" maxDOBirth={moment(requestedToDate).format('MM/DD/YYYY')} value={moment(requestedFromDate).format('MM/DD/YYYY')} callBackFun={(date) => {
                          setRequestedFromDate(date);
                          setFieldValue("fromDateOrderFilter", date);
                        }} />

                        <p style={{ 'margin-top': '5px' }}>To</p>
                        <DatePicker name="toDateOrderFilter" minDOBirth={moment(requestedFromDate).format('MM/DD/YYYY')} value={moment(requestedToDate).format('MM/DD/YYYY')} callBackFun={(date) => {
                          setRequestedToDate(date);
                          setFieldValue("toDateOrderFilter", date);
                        }} />
                      </div>
                    </SelectWrapper>
                  </ModalBody>
                  <ModalFooter>
                    <Button
                      type="app-green-button"
                      handleClick={() => {
                        callBackFun(props.values);
                        toggle();               
                      }}
                    >
                      Apply Filter
                    </Button>
                  </ModalFooter>
                </Modal>
              </Form>
            </>
          );
        }}
      </Formik>
    </div>
  );
};

const DropDownWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  .dropDown {
    div {
      p {
        margin: 12px;
      }
    }
  }
  label {
    padding: 5px;
    margin: 2px 0 0;
    font-size: 18px;
  }
`;
const SelectWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  > div {
    display: flex;
    p {
      margin: 12px;
    }
  }
  .dropDown {
    width: 200px;
  }
  select,
  // input {
  //   padding: 5px;
  //   border: solid 1px transparent !important;
  //   margin: 2px 0;
  //   font-size: 16px;
  //   padding: 10px 13px 10px 13px;
  //   border-radius: 5px;
  //   background-color: #e8e2e2;
  //   -webkit-appearance: none;
  //   -moz-appearance: none;
  //   appearance: none;
  //   ::-webkit-input-placeholder {
  //     /* Edge */
  //     color: #656565;
  //   }

  //   :-ms-input-placeholder {
  //     /* Internet Explorer 10-11 */
  //     color: #656565;
  //   }

  //   ::placeholder {
  //     color: #656565;
  //   }
  // }
  label {
    padding: 5px;
    margin: 2px 0 0;
    font-size: 18px;
  }
  @media (max-width: 650px) {
    > div {
      flex-direction: column;
    }
  }
`;
